import React from "react";
import { connect, useSelector } from "react-redux";
import {
  getAuthState,
  getAuthClaims,
  getAuthOptions,
  FormBuilder,
  Form,
  ErrorMessage,
  ScreenCheck,
  getResponsiveScreen,
} from "@redriver/cinnamon";
import { requestLogin } from "./actions";
import { Panel, Heading, BackgroundContent } from "components/containers";
import { RoundedButton } from "components/buttons";
import {
  ScreenBreakpoints,
  ScreenBreakpointNames,
} from "constants/breakpoints";
import classNames from "classnames";
import { Link } from "react-router-dom";
import { SystemRoutes } from "constants/routes";

const loginErrors = {
  915004: "Incorrect email address or password",
  915005: "Account is inactive",
};

const Login = ({ loggedIn, emailVerified, useEmailVerification }) => {
  const screen = useSelector(getResponsiveScreen);
  const isSmallScreen = screen?.screenSize == ScreenBreakpointNames.Small;

  if (loggedIn) {
    if (emailVerified || !useEmailVerification) {
      return <p>You have been successfully signed in</p>;
    }

    return (
      <div>
        <p>Your email address is not recognised</p>
      </div>
    );
  }

  const intro = (
    <div
      className={classNames({
        "mobile-header": isSmallScreen,
      })}
      style={{ marginBottom: "1em" }}
    >
      <Heading>Welcome to Select School Travel Reps Portal</Heading>
      <p style={{ marginTop: 0 }}>
        Please login with the details you were sent via email.
      </p>
    </div>
  );

  return (
    <div className="login">
      {isSmallScreen ? intro : null}
      <BackgroundContent />

      <Panel floating isBlue={isSmallScreen}>
        {!isSmallScreen ? intro : null}
        <FormBuilder
          submitAction={requestLogin}
          renderSubmitting={false}
          renderError={false}
          renderForm={(
            formProps,
            { submitting, slowSubmitting, error },
            events
          ) => (
            <Form {...formProps}>
              <Form.Email
                field="email"
                label="Email"
                placeholder="Enter email address"
                disabled={submitting && slowSubmitting}
                autoFocus
                required
                fluid
                icon="at"
              />
              <Form.Password
                field="password"
                label="Password"
                placeholder="Password"
                disabled={submitting && slowSubmitting}
                required
                fluid
                toggleVisibility
              />

              <div style={{ marginBottom: "20px" }}>
                <Link
                  to={SystemRoutes.ForgottenPassword}
                  className="float-right"
                >
                  Forgot your password?
                </Link>
              </div>

              <RoundedButton
                primary
                onClick={events.onSubmit}
                disabled={submitting}
                loading={submitting && slowSubmitting}
                fluid
              >
                Sign In
              </RoundedButton>
              <p>
                By signing in you are agreeing to our{" "}
                <a
                  href="https://selectschooltravel.com/about/gdpr-information"
                  target="_blank"
                >
                  GDPR policy
                </a>
              </p>
              {error && (
                <div className="login-error">
                  <ErrorMessage
                    header="Sign In Error"
                    error="Unable to sign in, please check your email and password are correct"
                  />
                </div>
              )}
            </Form>
          )}
        />
      </Panel>
    </div>
  );
};

const mapStateToProps = (state) => {
  const { loggedIn } = getAuthState(state);
  const { emailVerified } = getAuthClaims(state);
  const { useEmailVerification } = getAuthOptions();
  return {
    loggedIn,
    emailVerified,
    useEmailVerification,
  };
};

export default connect(mapStateToProps)(Login);
